import { getArtistsWithRolePlacement } from 'middleware/track/artistsWithRolePlacement';
import { DIGITAL_PRODUCT_TYPE, RELEASE_TYPE } from 'services/music-product-digital/types/enums';
import { IMusicProductDigitalForm } from 'services/music-product-digital/types/form';
import { IMusicProductDigitalMutation } from 'services/music-product-digital/types/mutation';
import { trimTitle, trimTitles } from 'utils/global/mainTitle.utils';
import { unknownEnumValueConverter } from 'utils/global/valueConverter';
import { convertAlbumsModelToTracks } from './albumsToTracks';
import { settlementInfoFormToQuery } from './settlementInfoFormToQuery';

export const musicProductDigitalFormToQuery = (
  musicProductDigitalForm: IMusicProductDigitalForm,
): IMusicProductDigitalMutation => {
  const { file, productImageLink, productImagePreviewLink, video, ...musicProductDigital } = {
    ...musicProductDigitalForm,
    releaseType: unknownEnumValueConverter<RELEASE_TYPE>(musicProductDigitalForm.releaseType),
    genre: unknownEnumValueConverter<number>(musicProductDigitalForm.genre.id),
    assignEan: musicProductDigitalForm.assignEan,
    ean: musicProductDigitalForm.assignEan
      ? null
      : musicProductDigitalForm.ean !== null
        ? `${musicProductDigitalForm.ean}`
        : null,
    cLine: !!musicProductDigitalForm.cLine?.name ? musicProductDigitalForm.cLine : null,
    pLine: !!musicProductDigitalForm.pLine?.name ? musicProductDigitalForm.pLine : null,
    tracks:
      musicProductDigitalForm.productType === DIGITAL_PRODUCT_TYPE.audio
        ? convertAlbumsModelToTracks(musicProductDigitalForm.tracks)
        : [],
    videoId:
      musicProductDigitalForm.productType === DIGITAL_PRODUCT_TYPE.video &&
      musicProductDigitalForm.videoId?.length
        ? musicProductDigitalForm.videoId
        : null,
    artists: getArtistsWithRolePlacement(musicProductDigitalForm.artists),
    releaseDate: !!musicProductDigitalForm.releaseDate.length
      ? new Date(musicProductDigitalForm.releaseDate).toISOString()
      : null,
    settlementInfo:
      (!musicProductDigitalForm.settlementInfo.perTrackSettlement &&
        musicProductDigitalForm.settlementInfo.contracts.length) ||
      (!!musicProductDigitalForm.settlementInfo.perTrackSettlement &&
        musicProductDigitalForm.settlementInfo.perTrackContracts.length)
        ? settlementInfoFormToQuery(
            musicProductDigitalForm.settlementInfo,
            musicProductDigitalForm.productType,
          )
        : null,
    mainTitle: trimTitle(musicProductDigitalForm.mainTitle),
    otherTitles: trimTitles(musicProductDigitalForm.otherTitles),
  };
  return musicProductDigital;
};
